export const USER_GROUP_REDUCER_KEYS = {
  REDUCER: 'userGroups',
  BY_ID: 'byID',
}
